import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import user_data from "../../data/user_data";
import User_items from "../../components/user/User_items";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { CopyToClipboard } from "react-copy-to-clipboard";
import Head from "next/head";
import Meta from "../../components/Meta";
import ProtectedRoute from "../../components/ProtectedRoute";
import moment from "moment";
import ClaimPOETForm from '../forms/ClaimPOETForm'
import { toast } from "react-toastify";
import { useAppDispatch, useAppState } from "../../components/AppContext";

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const UserProfileContainer = ({ isPublic }) => {
    const size = 1000
    const router = useRouter();
    const state = useAppState();
    const pid = router.query.user;
    const [likesImage, setLikesImage] = useState(false);
    const [copied, setCopied] = useState(false);
    const [user, setUser] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isClaimPoetModalOpen, setIsClaimPoetModalOpen] = useState(false);
    const isClaimed = false
    useEffect(() => {
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    }, [copied]);

    useEffect(() => {
        if ((state.id && state.access_token && router.pathname == '/account') || (pid && router.pathname != '/account')) {
            setLoading(true);
            setTimeout(() => {
                getUserArts(pid);
                getUserInfo(pid);
            }, 2000)
        }
    }, [state, pid]);

    useEffect(() => {
        let poet = localStorage.getItem('poet')
        poet = JSON.parse(poet) ?? null
        // if (router.query?.poet && !isClaimed) {
        if (poet && !poet.claimed && !isClaimed) {
            isClaimed = true
            userClaimLInk(poet.key)
        }
    }, [])

    const userClaimLInk = async (key) => {
        // if (router.query.poet) {
        if (key) {
            // await claimPoet({ phrase: router.query.poet })
            await claimPoet({ phrase: key })
            localStorage.setItem('poet', JSON.stringify({key: key, claimed: true}))
            router.replace('/account')
        }
    }

    const handleLikes = async () => {
        setLoading(true);
        try {
            let url = `${BASE_URL}v1/user/profile/like`
            let body = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + state.access_token,
                },
                body: JSON.stringify({ user: user.id })
            }
            const resp = await fetch(url, body);
            const jsonRes = await resp.json();
            setLoading(false);
            if (jsonRes.success) {
                getUserInfo(pid);
            }
        } catch (e) {
            // setError("Something went wrong.");
            setLoading(false);
        }
    };

    const getUserArts = async (username) => {
        try {
            let url = `${BASE_URL}v1/user/arts/get-user-arts`
            let body = {
                method: "POST",
                body: JSON.stringify({
                    page: 1,
                    size: size,
                    user_id: state.id,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + state.access_token,
                },
            }
            if (username) {
                url = `${BASE_URL}v1/public/arts/get-user-arts`
                body = {
                    method: "POST",
                    body: JSON.stringify({
                        page: 1,
                        size: size,
                        user: username,
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            }
            const resp = await fetch(url, body);
            const jsonRes = await resp.json();
            if (jsonRes.data) {
                setData(jsonRes.data);
            } else {
                router.push('/user-not-found')
            }
            setLoading(false);
        } catch (e) {
            router.push('/user-not-found')
            setData([]);
            setLoading(false);
        }
    };

    const getUserInfo = async (username) => {
        try {
            let url = `${BASE_URL}v1/user/profile/info`
            let body = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + state.access_token,
                },
            }
            if (username) {
                url = `${BASE_URL}v1/public/user/info?user=${username}`
                body = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            }
            const resp = await fetch(url, body);
            const jsonRes = await resp.json();
            if (jsonRes.success) {
                setUser(jsonRes.data);
                // setLoading(false);
                if (state?.id) {
                    if (jsonRes.user.user.filter(i => i.likedById == state.id)?.length) {
                        setLikesImage(true)
                    }
                }
            } else {
                // setLoading(false);
                // setError(jsonRes.message);
            }
        } catch (e) {
            // setError("Something went wrong.");
            // setLoading(false);
        }
    };

    const claimPoet = async ({ phrase }) => {
        if(phrase && phrase != undefined && phrase != 'undefined'){
            setLoading(true);
            try {
                let url = `${BASE_URL}v1/user/arts/claim-poet`
                let body = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + state.access_token,
                    },
                    body: JSON.stringify({ phrase: phrase })
                }
                const resp = await fetch(url, body);
                const jsonRes = await resp.json();
                console.log(jsonRes)
                if (jsonRes.success) {
                    setIsClaimPoetModalOpen(false)
                    toast.success(jsonRes?.message)
                    getUserArts(pid);
                    return
                }
                toast.error(jsonRes?.message)
                setLoading(false);
            } catch (e) {
                setLoading(false);
            }
        }
    }

    return (
        <>
            {loading && (
                <div className="poet-overlay">
                    <div className="poet-overlay__inner">
                        <div className="poet-overlay__content">
                            <span className="swiper-lazy-preloader"></span>
                        </div>
                    </div>
                </div>
            )}
            <Meta title="Account - POET" />
            {/* <!-- Profile --> */}
            {user_data
                .filter((item) => item.id === "avatar_1")
                .map((item) => {
                    const {
                        id,
                        title,
                        icon,
                    } = item;
                    return (
                        <div className="pt-[5.5rem] lg:pt-24" key={id}>
                            {/* <!-- Banner --> */}
                            {/* <div className="relative h-[18.75rem]"> */}
                            <div
                                className="relative h-[7.00rem]"
                                style={{ background: "#101436" }}
                            >
                            </div>
                            {/* <!-- end banner --> */}
                            <section className="dark:bg-jacarta-800 bg-light-base relative pb-8 pt-28">
                                {/* <!-- Avatar --> */}
                                <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
                                    <figure className="relative h-40 w-40 dark:border-jacarta-600 rounded-xl border-[5px] border-white">
                                        <Image
                                            src={
                                                user?.profile_image
                                                    ? user?.profile_image
                                                    : "/images/user-profile.png"
                                            }
                                            alt={title}
                                            layout="fill"
                                            objectFit="contain"
                                            className="dark:border-jacarta-600 rounded-xl border-[5px] border-white"
                                        />
                                        {
                                            user?.is_verified &&
                                            <div
                                                className="dark:border-jacarta-600 bg-green absolute -right-3 bottom-0 flex h-6 w-6 items-center justify-center rounded-lg border-2 border-white"
                                                data-tippy-content="Verified Collection"
                                            >
                                                {icon && (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        width="24"
                                                        height="24"
                                                        className="h-[.875rem] w-[.875rem] fill-white"
                                                    >
                                                        <path fill="none" d="M0 0h24v24H0z"></path>
                                                        <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                                                    </svg>
                                                )}
                                            </div>
                                        }
                                    </figure>
                                </div>
                                <div className="container">
                                    <div className="text-center">
                                        <h2 className="font-display text-jacarta-700 mb-2 text-4xl font-medium dark:text-white">
                                            {user?.username}
                                        </h2>
                                        <p className="text-white lowercase">{user?.email_address}</p>

                                        <p className="dark:text-jacarta-300 mx-auto mb-2 max-w-xl text-lg">
                                            {/* {text} */}
                                        </p>
                                        <span className="text-jacarta-400">
                                            Joined {moment(user?.createdAt).format("MMMM YYYY")}
                                        </span>

                                        <div className="mt-6 flex items-center justify-center space-x-2.5 relative">
                                            <div className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white">
                                                <div className="js-likes relative inline-flex h-10 w-10 cursor-pointer items-center justify-center text-sm">
                                                    <button onClick={handleLikes}>
                                                        {likesImage ? (
                                                            <svg className="icon dark:fill-jacarta-200 fill-jacarta-500 h-4 w-4">
                                                                <use xlinkHref="/icons.svg#icon-heart-fill"></use>
                                                            </svg>
                                                        ) : (
                                                            <svg className="icon dark:fill-jacarta-200 fill-jacarta-500 h-4 w-4">
                                                                <use xlinkHref="/icons.svg#icon-heart"></use>
                                                            </svg>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <Social_dropdown user={user} />

                                            <Auctions_dropdown classes="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white relative" />
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {/* <!-- end profile --> */}

                            <User_items data={data} isPublic={isPublic} activities={user?.activities} setIsClaimPoetModalOpen={setIsClaimPoetModalOpen} />
                        </div>
                    );
                })}
            {/* CLaim POET Modal */}
            <div
                className={isClaimPoetModalOpen ? "modal fade show block" : "modal fade"}
            >
                <div className="modal-dialog max-w-2xl full-mobile-width">
                    <div className="modal-content min-w-modal border-accent-dark border-1">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addPropertiesLabel">
                                Claim POET
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setIsClaimPoetModalOpen(false)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                                >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                                </svg>
                            </button>
                        </div>
                        <div className="modal-body p-6">
                            <ClaimPOETForm
                                submitBtnTxt="Claim"
                                allowSelect={false}
                                nextHandler={claimPoet}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserProfileContainer;
